(function () {
  'use strict';

  var instances = new WeakMap();

  function highResolutionUrl(src) {
    if (!src) return '';
    return src.replace(/_{width}x(?=\.)/i, '_2048x2048').replace(/_(\d+x\d+)(?=\.[a-z]{2,5}(?:\?|$))/i, '_2048x2048');
  }

  function isVisible(element) {
    return Boolean(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
  }

  function createLightbox(element) {
    if (instances.has(element)) return instances.get(element);
    var sectionId = element.getAttribute('data-section-id');
    var section = document.querySelector('[data-section-id="' + sectionId + '"]');
    if (!section) return null;

    var dialog = element.querySelector('[data-pdp-lightbox-dialog]');
    var viewport = element.querySelector('[data-pdp-lightbox-viewport]');
    var image = element.querySelector('[data-pdp-lightbox-image]');
    var thumbs = element.querySelector('[data-pdp-lightbox-thumbs]');
    var count = element.querySelector('[data-pdp-lightbox-count]');
    var previous = element.querySelector('[data-pdp-lightbox-previous]');
    var next = element.querySelector('[data-pdp-lightbox-next]');
    var closeButton = element.querySelector('[data-pdp-lightbox-close]');
    var items = [];
    var index = 0;
    var scale = 1;
    var panX = 0;
    var panY = 0;
    var dragStart = { x: 0, y: 0, panX: 0, panY: 0 };
    var pinchDistance = 0;
    var pinchScale = 1;
    var pointers = new Map();
    var moved = false;
    var opener = null;
    var imageRequest = 0;
    var loadedImages = {};

    function addZoomTriggers() {
      Array.prototype.forEach.call(section.querySelectorAll('.pdp-carousel__image-stage, .pdp-mobile-slider, .product-single__photos'), function (stage) {
        if (stage.querySelector('[data-pdp-lightbox-trigger], [data-pdp-zoom]')) return;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'pdp-media-zoom-trigger';
        button.setAttribute('data-pdp-lightbox-trigger', '');
        button.setAttribute('aria-label', 'Open image gallery');
        button.innerHTML = '<span class="icon icon-search" aria-hidden="true"></span><span class="pdp-media-zoom-trigger__plus" aria-hidden="true">+</span>';
        stage.appendChild(button);
      });
    }

    function activeThumbList() {
      return Array.prototype.slice.call(section.querySelectorAll('.ProductThumbs, .product-single__thumbnails')).find(isVisible);
    }

    function collectItems() {
      var list = activeThumbList();
      var links = list ? Array.prototype.slice.call(list.querySelectorAll('a.product-single__thumbnail')) : [];
      var seen = {};
      items = links.reduce(function (result, link) {
        if (link.closest('.is-clone')) return result;
        var thumbImage = link.querySelector('img');
        var id = String(link.getAttribute('data-image-id') || '');
        var src = highResolutionUrl(link.getAttribute('href') || (thumbImage && (thumbImage.currentSrc || thumbImage.src)) || '');
        if (!src || seen[id + src]) return result;
        seen[id + src] = true;
        result.push({ id: id, src: src, thumb: thumbImage ? thumbImage.currentSrc || thumbImage.src : src, alt: thumbImage ? thumbImage.alt : '' });
        return result;
      }, []);

      if (!items.length) {
        items = Array.prototype.slice.call(section.querySelectorAll('.product-single__image-wrapper img')).reduce(function (result, mainImage) {
          var wrapper = mainImage.closest('[data-image-id]');
          var id = String(wrapper ? wrapper.getAttribute('data-image-id') : '');
          var src = highResolutionUrl(mainImage.getAttribute('data-zoom') || mainImage.getAttribute('data-src') || mainImage.currentSrc || mainImage.src);
          if (!src || seen[id + src]) return result;
          seen[id + src] = true;
          result.push({ id: id, src: src, thumb: mainImage.currentSrc || mainImage.src, alt: mainImage.alt || '' });
          return result;
        }, []);
      }
    }

    function setTransform(nextScale, nextX, nextY) {
      scale = Math.max(1, Math.min(4, nextScale));
      if (scale === 1) {
        panX = 0;
        panY = 0;
      } else {
        var maxX = viewport.clientWidth * (scale - 1) / 2;
        var maxY = viewport.clientHeight * (scale - 1) / 2;
        panX = Math.max(-maxX, Math.min(maxX, nextX));
        panY = Math.max(-maxY, Math.min(maxY, nextY));
      }
      image.style.setProperty('--pdp-zoom', scale);
      image.style.setProperty('--pdp-pan-x', panX + 'px');
      image.style.setProperty('--pdp-pan-y', panY + 'px');
      viewport.classList.toggle('is-zoomed', scale > 1);
    }

    function resetZoom() {
      setTransform(1, 0, 0);
      viewport.classList.remove('is-dragging', 'is-pinching');
      pointers.clear();
    }

    function renderThumbs() {
      thumbs.innerHTML = '';
      items.forEach(function (item, itemIndex) {
        var button = document.createElement('button');
        var thumbImage = document.createElement('img');
        button.type = 'button';
        button.className = 'pdp-media-lightbox__thumb';
        button.setAttribute('aria-label', 'View image ' + (itemIndex + 1) + ' of ' + items.length);
        button.addEventListener('click', function () { show(itemIndex); });
        thumbImage.src = item.thumb;
        thumbImage.alt = '';
        button.appendChild(thumbImage);
        thumbs.appendChild(button);
      });
    }

    function preload(item) {
      if (!item || !item.src || loadedImages[item.src]) return;
      var loader = new Image();
      loadedImages[item.src] = loader;
      loader.src = item.src;
    }

    function loadFullImage(item, request) {
      if (!item || !item.src || item.src === item.thumb) return;
      var loader = loadedImages[item.src] || new Image();
      loadedImages[item.src] = loader;
      var apply = function () {
        if (request === imageRequest && items[index] === item) image.src = item.src;
      };
      if (loader.complete && loader.naturalWidth) {
        apply();
      } else {
        loader.onload = apply;
        loader.src = item.src;
      }
    }

    function show(nextIndex) {
      if (!items.length) return;
      index = (nextIndex + items.length) % items.length;
      imageRequest += 1;
      var request = imageRequest;
      var item = items[index];
      resetZoom();
      image.src = item.thumb || item.src;
      image.alt = item.alt || 'Product image ' + (index + 1);
      loadFullImage(item, request);
      preload(items[(index + 1) % items.length]);
      preload(items[(index - 1 + items.length) % items.length]);
      count.textContent = (index + 1) + '/' + items.length;
      Array.prototype.forEach.call(thumbs.querySelectorAll('.pdp-media-lightbox__thumb'), function (button, buttonIndex) {
        var active = buttonIndex === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
        if (active) button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
      var single = items.length < 2;
      previous.hidden = single;
      next.hidden = single;
      thumbs.hidden = single;
    }

    function open(trigger) {
      collectItems();
      if (!items.length) return;
      opener = trigger;
      var sourceImage = trigger.matches('[data-pdp-lightbox-trigger]')
        ? section.querySelector('.product-single__image-wrapper:not(.hide) img')
        : trigger;
      var wrapper = sourceImage ? sourceImage.closest('[data-image-id]') : null;
      var activeId = wrapper ? String(wrapper.getAttribute('data-image-id') || '') : '';
      var activeIndex = items.findIndex(function (item) { return activeId && item.id === activeId; });
      renderThumbs();
      element.hidden = false;
      element.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pdp-media-lightbox-open');
      show(activeIndex >= 0 ? activeIndex : 0);
      closeButton.focus();
    }

    function close() {
      resetZoom();
      element.hidden = true;
      element.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pdp-media-lightbox-open');
      image.removeAttribute('src');
      if (opener && typeof opener.focus === 'function') opener.focus();
    }

    function step(direction) { show(index + direction); }
    function distance() {
      var points = Array.from(pointers.values());
      return points.length < 2 ? 0 : Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y);
    }

    section.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-pdp-lightbox-trigger], .pdp-carousel .product-single__image-wrapper img, .pdp-mobile-slider .product-single__image-wrapper img, .grid .product-single__image-wrapper img');
      if (!trigger || !section.contains(trigger)) return;
      event.preventDefault();
      open(trigger);
    });
    closeButton.addEventListener('click', close);
    previous.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    element.addEventListener('click', function (event) { if (event.target === element) close(); });
    viewport.addEventListener('click', function () {
      if (moved || pointers.size) return;
      setTransform(scale > 1 ? 1 : 2.5, 0, 0);
    });
    viewport.addEventListener('pointerdown', function (event) {
      viewport.setPointerCapture(event.pointerId);
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      moved = false;
      dragStart = { x: event.clientX, y: event.clientY, panX: panX, panY: panY };
      if (pointers.size === 2) {
        pinchDistance = distance();
        pinchScale = scale;
        viewport.classList.add('is-pinching');
      } else if (scale > 1) {
        viewport.classList.add('is-dragging');
      }
    });
    viewport.addEventListener('pointermove', function (event) {
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (pointers.size === 2) {
        var nextDistance = distance();
        if (pinchDistance) setTransform(pinchScale * nextDistance / pinchDistance, panX, panY);
        moved = true;
      } else if (scale > 1) {
        var deltaX = event.clientX - dragStart.x;
        var deltaY = event.clientY - dragStart.y;
        if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) moved = true;
        setTransform(scale, dragStart.panX + deltaX, dragStart.panY + deltaY);
      } else if (Math.abs(event.clientX - dragStart.x) > 8 || Math.abs(event.clientY - dragStart.y) > 8) {
        moved = true;
      }
    });
    function releasePointer(event) {
      var swipeDistance = event.clientX - dragStart.x;
      var shouldSwipe = pointers.size === 1 && scale === 1 && moved && Math.abs(swipeDistance) > 50;
      pointers.delete(event.pointerId);
      viewport.classList.remove('is-dragging');
      if (pointers.size < 2) viewport.classList.remove('is-pinching');
      if (shouldSwipe) step(swipeDistance < 0 ? 1 : -1);
      window.setTimeout(function () { moved = false; }, 0);
    }
    viewport.addEventListener('pointerup', releasePointer);
    viewport.addEventListener('pointercancel', releasePointer);
    document.addEventListener('keydown', function (event) {
      if (element.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') step(-1);
      if (event.key === 'ArrowRight') step(1);
      if (event.key === 'Tab') {
        var focusable = Array.prototype.slice.call(dialog.querySelectorAll('button:not([hidden])'));
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });

    addZoomTriggers();
    var api = { open: open, close: close, refresh: collectItems };
    instances.set(element, api);
    return api;
  }

  function initialize(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-pdp-lightbox]'), createLightbox);
  }

  document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
}());
